import axios from "axios"
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 * 查詢文件類型
 * @param {*} serviceType  
 */
const get = (serviceType) => {
    return axios.get(`${basePath}/public/api/v1/document-type?serviceType=${serviceType}`).then(res => res.data)
}

export default {
    get
}